<template>
  <article class="edit-category-component">
    <ProductCategoryForm
      :product-category="localProductCategory"
      @update:category-data="onChangeCategoryData"
      @close="closeCard"
    />

    <template v-if="(localProductCategory.isLeaf === true || localProductCategory.allowsProducts === true) && localProductCategory.id">
      <ProductCategoryAllowedUnits
        class="grid-block"
        :product-category="localProductCategory"
        @change="loadProductCategory"
      />

      <ProductCategoryCharacteristics
        class="grid-block"
        :product-category="localProductCategory"
        @load-product-category="loadProductCategory"
      />
    </template>
  </article>
</template>

<style lang="scss" src="./ProductCategoryEditor.scss"/>

<script lang="ts">

import ProductCategory                from "@/domains/ProductCategories/ProductCategory";
import ProductCategoriesService       from '@/domains/ProductCategories/ProductCategoriesService';

import ProductCategoryForm            from '@/domains/ProductCategories/components/ProductCategoryEditor/ProductCategoryForm.vue';
import ProductCategoryCharacteristics from '@/domains/ProductCategories/components/ProductCategoryEditor/ProductCategoryCharacteristics.vue';
import ProductCategoryAllowedUnits    from '@/domains/ProductCategories/components/ProductCategoryEditor/ProductCategoryAllowedUnits.vue';

export default defineComponent({
  name: 'ProductCategoryEditor',

  components: {
    ProductCategoryForm,
    ProductCategoryCharacteristics,
    ProductCategoryAllowedUnits,
  },

  props: {
    productCategory: {
      type:    Object as PropType<ProductCategory>,
      default: null,
    },
  },

  emits: ['update:product-category', 'close'],

  data() {
    return {
      localProductCategory: this.$core.utils.cloneDeep(this.productCategory),
    };
  },

  methods: {

    /** Здесь НЕ занулять localProductCategory: компонент размонтирует родитель
     * через v-if/key. Зануление до размонтирования роняло рендер
     * на localProductCategory.isLeaf при ре-рендере. */

    onChangeCategoryData(productCategory) {
      this.$emit('update:product-category', productCategory);
    },

    async loadProductCategory() {
      this.localProductCategory = await ProductCategoriesService.get(
        this.productCategory.id,
        {
          requireAllowedUnits:    true,
          requireCharacteristics: true,
        },
      );
    },

    closeCard() {
      this.$emit('close');
    },
  },
});
</script>